import { memo } from "react";

function NextStopComplianceStopLGMarker({ stopSequence, textColor, color }) {
  const shiftLeft = stopSequence && stopSequence < 10 ? 0 : -3;
  return (
    <svg
      width="35"
      height="35"
      viewBox="0 0 30 30"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      {/* Generator: Sketch 52.5 (67469) - http://www.bohemiancoding.com/sketch */}
      <desc>Created with Sketch.</desc>
      <g
        id="Map-interactions"
        stroke="none"
        strokeWidth={1}
        fill="none"
        fillRule="evenodd"
      >
        <g id="Stops-on-map-" transform="translate(1.000000, 1.000000)">
          <path
            d="M13.7125339,7.50054975 C13.958556,11.1357611 16.8642389,14.041444 20.4994503,14.2874661 C20.8244859,15.2999889 21,16.3794977 21,17.5 C21,23.2989899 16.2989899,28 10.5,28 C4.70101013,28 0,23.2989899 0,17.5 C0,11.7010101 4.70101013,7 10.5,7 C11.6205023,7 12.7000111,7.1755141 13.7125339,7.50054975 Z"
            id="Combined-Shape"
            stroke={textColor}
            fill={color}
          />
          <circle
            id="Oval-15"
            stroke={textColor}
            fill={color}
            cx={22}
            cy={6}
            r={6}
          />
          <g
            id="Liftgate-(1)"
            transform="translate(5.500000, 13.000000)"
            fill={textColor}
            fillRule="nonzero"
          >
            <path
              d="M8.25,3.75 L5.625,2 L8.45014015,0.184121683 C8.49659927,0.154259762 8.51005396,0.0923893306 8.48019204,0.0459302079 C8.46179269,0.0173045294 8.43009925,-1.30154095e-15 8.39607036,-3.88578059e-16 L6.44382098,-3.55271368e-15 L5,0.937036419 L3.44135058,-1.0269563e-15 L1.42302802,-7.77156117e-16 C1.36779955,-7.67010811e-16 1.32302802,0.044771525 1.32302802,0.1 C1.32302802,0.134344237 1.34065243,0.166285654 1.36970708,0.184598326 L4.25,2 L1.625,3.75 C1.1875,4 1.1875,4.625 1.625,4.875 L3.96440174,6.40788869 L1.17883075,8.3808961 C1.13376215,8.41281798 1.12310464,8.47523109 1.15502652,8.52029968 C1.17377414,8.54676832 1.20419491,8.5625 1.23663042,8.5625 L3.17176663,8.5625 L5,7.33159769 L6.78070522,8.5625 L8.85364905,8.5625 C8.90887752,8.5625 8.95364905,8.51772847 8.95364905,8.4625 C8.95364905,8.42923699 8.9371096,8.39815123 8.90952318,8.3795658 L5.98295535,6.40788869 L8.25,4.875 C8.6875,4.625 8.6875,4 8.25,3.75 Z M4.98200593,5.73328266 L2.97949094,4.39151317 L4.98200593,3.0766729 L7.00520516,4.40497778 L4.98200593,5.73328266 Z"
              id="Shape"
            />
            <path
              d="M9.625,10 L0.375,10 C0.1875,10 -3.41060513e-13,9.76912958 -3.41060513e-13,9.45235219 C-3.40883419e-13,9.13557479 0.1875,8.90470438 0.375,8.90470438 L9.625,8.90470438 C9.8125,8.90470438 10,9.18377629 10,9.45235219 C10,9.72092809 9.8125,10 9.625,10 Z"
              id="Shape"
            />
          </g>
          <text
            id={2}
            fontFamily="OpenSans-SemiBold, Open Sans"
            fontSize={8}
            fontWeight={500}
            fill={textColor}
          >
            <tspan x={20 + shiftLeft} y={9}>
              {stopSequence}
            </tspan>
          </text>
        </g>
      </g>
    </svg>
  );
}

export default memo(NextStopComplianceStopLGMarker);
